import { pBtn, pBtnSmall } from "components/main.styled";
import styled from "styled-components";

export const SortContainerButtons = styled.div`
    padding: 10px 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

button{
    padding: 7px 10px;
    border: 1px solid #e1e7eb;
    background: #f2f6f8;
    color: #626b70;
    cursor: pointer;
    transition: 0.25s;
    border-radius: 7px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:hover{
        background: #eef1f3;
        border-color: #d8e0e5;
    }
}

@media (max-width: 768px) {
    padding: 0px;
}

`

export const FIH = styled.h3`
    color: var(--lightThemeFontColor);
    font-size: 18px;
    margin-bottom: 10px;
    font-weight: 500;
    width: 100%;
    text-align: left;

`

export const FileInputWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: flex-start;
    border: 1px solid #dfe7ec;
    border-radius: 8px;
    padding: 10px 14px;
    margin-bottom: 10px;
    background: #fbfcfd;
`


export const GoBackButton = styled(pBtnSmall)`
    color: #626b70;
    border: 1px solid #e1e7eb;
    background-color: #f2f6f8;
    border-radius: 7px;
    transition: 0.25s;
    &:hover{ 
        background-color: #eef1f3;
    }

`

export const FolderFeedContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 15px;
    flex-wrap: wrap; 
    height: fit-content;
 
    /* remove scrollbar */

    &::-webkit-scrollbar {
        width: 0px;
    }

    @media (max-width: 768px) {
        gap: 5px;
        
    }
`

export const FilesFeedContainer = styled.div`

    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

`

export const FileModal = styled.div`
    z-index: 0;
    width: 500px;
    height: fit-content;
    background: white;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    border-radius: 8px;
    border: 1px solid #edf0f2;
    box-shadow: 0 10px 28px rgba(61, 70, 78, 0.16);
    position: relative;
    animation: animate 0.3s;
    padding: 25px;
    @media (max-width: 768px) {
        align-self: center;
        justify-self: center;
        width: 100%;
        height: fit-content
    }
`

export const FileFormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;

`

export const FileUploadInput = styled.input`
    width: 100%;
    color: var(--lightThemeFontColor);
    padding: 12px;
    outline: none;
    border: 1px solid #dfe7ec;
    border-radius: 8px;
    font-size: 15px;
    background-color: #fbfcfd;
    transition: 0.25s;

    &:focus{
        border-color: #21ad46;
        box-shadow: 0 0 0 3px rgba(33, 173, 70, 0.12);
    }
`

export const FileUploadButton = styled(pBtn)` 
    color: ${props => props.disabled ? 'white' : '#168236'};
    border: 1px solid ${props => props.disabled ? '#21ad46' : '#cdebd5'};
    background-color: ${props => props.disabled ? '#21ad46' : '#eef9f1'};
    border-radius: 7px;
    font-weight: 700;
    pointer-events: ${props => props.disabled ? 'none' : 'all'};

    @media (max-width: 768px) {
        align-self: center;
        justify-self: center;
    }
    &:hover{ 
        color: white;
        border: 1px solid #21ad46;
        background-color: #21ad46;
        transform: translateY(-1px);
    }
`
export const ButttonWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: ${props => props.justify ? props.justify : 'flex-end'};
    align-items: center; 
    margin-top: 20px; 
    padding: ${props => props.padding ? props.padding : '0px'};
`   

export const DroTitle = styled.div`
    width: 100px;
    display: flex;
    color: var(--lightThemeFontColor);
    align-items: center;    
    justify-content: center;
`   


export const FolderSelect = styled.div`

    width: 100%; 
    border-radius: 5px;
    /* border: 1px solid var(--borderColor); */
    margin-top: 10px;

`


export const FormWrap = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    justify-content: center;
`

export const BulletinFile = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: flex-end;
    border-radius: 5px;
    justify-content: space-between;
    /* border: 1px solid var(--borderColor); */
`

export const BulletinFileChild1 = styled.div`
    display: flex;
    flex-direction: column;
    width: 65%;
    align-items: flex-start;
    
`

export const BulletinFileName = styled.div`
    background-color: #f2f6f8;
    border: 1px solid #e1e7eb;
    padding: 10px;
    border-radius: 8px;
    width: 100%;
    color: var(--lightThemeFontColor);
`

export const ChooseFileBtn = styled.label` 
    pointer-events: ${props => props.disabled ? 'none' : 'auto'};

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    height: 38px;
    background-color: #eef9f1;
    color: #168236;
    border: 1px solid #cdebd5;
    cursor: pointer; 
    transition: 0.4s;
    font-size: 12px;
    justify-content: center;
    width: fit-content;
    min-width: 120px;

    border-radius: 7px;
    font-weight: 700;

    &:hover{
        background-color: #21ad46;
        color: white;
    }
`
